var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 19.4721H9.5M14.5 19.4721L19.3994 19.4994C19.4549 19.4997 19.5 19.4549 19.5 19.3994V8.62786C19.5 8.57263 19.4552 8.52786 19.4 8.52786H14.5M14.5 19.4721V8.52786M9.5 19.4721H4.6C4.54477 19.4721 4.5 19.4274 4.5 19.3721V11.6C4.5 11.5448 4.54477 11.5 4.6 11.5H9.5M9.5 19.4721V11.5M9.5 11.5V4.6C9.5 4.54477 9.54477 4.5 9.6 4.5H14.4C14.4552 4.5 14.5 4.54477 14.5 4.6V8.52786",
    stroke: "#EFEFEF",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.60c2739139ad8fdfe8d74fa8e09cb4c3.svg";
export { ForwardRef as ReactComponent };